<template>
  <keep-alive
    :exclude="['AutoRewardsConfirmation', 'RedeemPage', 'RewardConfirmation']"
  >
    <router-view />
  </keep-alive>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  created() {
    this.initHealthActions()
    this.initRewards()
  },
  methods: {
    ...mapActions('healthActions', ['initHealthActions']),
    ...mapActions('rewards', ['initRewards']),
  },
}
</script>

<style></style>